import * as networkService from '../services/networkService'
export const UPDATE_PROPERTY_ID = 'UPDATE_PROPERTY_ID'

export const PUBLIC_BROKER_REQUEST = 'PUBLIC_BROKER_REQUEST'
export const PUBLIC_BROKER_SUCCESS = 'PUBLIC_BROKER_SUCCESS'
export const PUBLIC_BROKER_FAIL = 'PUBLIC_BROKER_FAIL'

export const PUBLIC_PROPERTY_INFO_REQUEST = 'PUBLIC_PROPERTY_INFO_REQUEST'
export const PUBLIC_PROPERTY_INFO_SUCCESS = 'PUBLIC_PROPERTY_INFO_SUCCESS'
export const PUBLIC_PROPERTY_INFO_FAIL = 'PUBLIC_PROPERTY_INFO_FAIL'

export const APPLICATION_PROFILE_REQUEST = 'APPLICATION_PROFILE_REQUEST'
export const APPLICATION_PROFILE_SUCCESS = 'APPLICATION_PROFILE_SUCCESS'
export const APPLICATION_PROFILE_FAIL = 'APPLICATION_PROFILE_FAIL'

export const PHASE_INFORMATION_REQUEST = 'PHASE_INFORMATION_REQUEST'
export const PHASE_INFORMATION_SUCCESS = 'PHASE_INFORMATION_SUCCESS'
export const PHASE_INFORMATION_FAIL = 'PHASE_INFORMATION_FAIL'

export const APPLICATION_UPDATE_REQUEST = 'APPLICATION_UPDATE_REQUEST'
export const APPLICATION_UPDATE_SUCCESS = 'APPLICATION_UPDATE_SUCCESS'
export const APPLICATION_UPDATE_FAIL = 'APPLICATION_UPDATE_FAIL'

export const CLEAR_FLOW_ERRORS = 'CLEAR_FLOW_ERRORS'
export const RESET_FLOW = 'RESET_FLOW'

const flowActions = {
  applicationProfile: {
    pending: () => ({ type: APPLICATION_PROFILE_REQUEST, applicationProfileError: undefined }),
    success: (application, applicationProfileError) => ({
      type: APPLICATION_PROFILE_SUCCESS,
      application,
      applicationProfileError,
    }),
    error: applicationProfileError => ({ type: APPLICATION_PROFILE_FAIL, applicationProfileError }),
  },
}

export function resetFlow() {
  return dispatch => {
    dispatch({
      type: RESET_FLOW,
    })
  }
}

export function clearFlowErrors() {
  return {
    type: CLEAR_FLOW_ERRORS,
  }
}

export function getBroker(brokerId) {
  return dispatch => {
    dispatch({ type: PUBLIC_BROKER_REQUEST })
    return networkService
      .getBrokerPublicInformation(brokerId)
      .then(response => {
        dispatch({
          type: PUBLIC_BROKER_SUCCESS,
          property: response.data,
        })
        return response.data
      })
      .catch(() => {
        return dispatch({
          type: PUBLIC_BROKER_FAIL,
        })
      })
  }
}

export function updatePropertyID(propertyInfoId) {
  return dispatch => {
    dispatch({
      type: UPDATE_PROPERTY_ID,
      propertyInfoId: propertyInfoId,
    })
  }
}

export function getPropertyInformation(propertyId) {
  return dispatch => {
    dispatch({ type: PUBLIC_PROPERTY_INFO_REQUEST })
    return networkService
      .getPropertyPublicInformation(propertyId)
      .then(response => {
        dispatch({
          type: PUBLIC_PROPERTY_INFO_SUCCESS,
          property: response.data,
        })
        return response.data
      })
      .catch(() => {
        return dispatch({
          type: PUBLIC_PROPERTY_INFO_FAIL,
        })
      })
  }
}

export function getApplicationProfile(user) {
  return dispatch => {
    dispatch(flowActions.applicationProfile.pending())
    return networkService
      .getApplicationProfile(user.id)
      .then(response => {
        if (!response) {
          return
        }

        dispatch(flowActions.applicationProfile.success(response.data))
        return response.data
      })
      .catch(err => {
        dispatch(flowActions.applicationProfile.error(err))
        throw err
      })
  }
}

export function getPhaseInformation(userId, propertyId) {
  return dispatch => {
    dispatch({ type: PHASE_INFORMATION_REQUEST, phaseInformationError: undefined })
    return networkService
      .getPhaseInformation({ userId, propertyId })
      .then(response => {
        try {
          dispatch({
            type: PHASE_INFORMATION_SUCCESS,
            step: response.data.step,
            completedAt: response.data.completedAt,
            phaseInformationError: undefined,
          })

          return response.data
        } catch (error) {
          console.warn('FAILURE')
        }

        return {}
      })
      .catch(err => {
        dispatch({
          type: PHASE_INFORMATION_FAIL,
          phaseInformationError: err,
        })
        return Promise.reject(err)
      })
  }
}

export function softUpdateApplicationInformation(params) {
  return dispatch => {
    dispatch({
      type: APPLICATION_UPDATE_SUCCESS,
      application: params,
    })
  }
}

export function updateApplicationInformation(params = {}) {
  return dispatch => {
    dispatch({ type: APPLICATION_UPDATE_REQUEST })
    return networkService
      .updateApplicationProfile(params)
      .then(response => {
        dispatch({
          type: APPLICATION_UPDATE_SUCCESS,
          application: response.data,
        })
        return response.data
      })
      .catch(err => {
        dispatch({
          type: APPLICATION_UPDATE_FAIL,
        })
        return Promise.reject(err)
      })
  }
}

export const getAllData = (propertyId, user) => {
  const actions = [
    getPropertyInformation(propertyId),
    getApplicationProfile(user),
    getPhaseInformation(user.id, propertyId),
  ]
  return dispatch => actions.map(a => dispatch(a))
}



// WEBPACK FOOTER //
// ./src/actions/FlowAction.js